import { getJson, patchJson, postJson } from './client'
import type {
  AssigneeView, LedgerOverview, PatchRequirementBody, PatchTakeawayBody, TakeawayView, Transcript, TranscriptLedgerView, TranscriptRequirement, TranscriptsPage,
} from '../types/transcripts'
import type { JobView } from '../types/voice'

// Meeting transcripts: the firm's scribe library, in project context, and the ledger read out of each one.
const base = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/transcripts`

export const transcriptsApi = {
  list: (spoke: string, project?: string) => getJson<TranscriptsPage>(base(spoke), project ? { project } : undefined),
  get: (spoke: string, id: string) => getJson<Transcript>(`${base(spoke)}/${encodeURIComponent(id)}`),
  import: (spoke: string) => postJson<JobView>(`${base(spoke)}/import`, {}),
  /** The library's ledger at a glance: totals and per-transcript counts, computed against today. */
  overview: (spoke: string) => getJson<LedgerOverview>(`${base(spoke)}/ledger`),
  ledger: (spoke: string, id: string) => getJson<TranscriptLedgerView>(`${base(spoke)}/${encodeURIComponent(id)}/ledger`),
  assignees: (spoke: string) => getJson<AssigneeView[]>(`${base(spoke)}/assignees`),
  /** Starts the transcript-extract job: one transcript, or every transcript not yet read. 202 + the job. */
  extract: (spoke: string, id?: string) => postJson<JobView>(id ? `${base(spoke)}/${encodeURIComponent(id)}/extract` : `${base(spoke)}/extract`, {}),
  patchTakeaway: (spoke: string, id: string, body: PatchTakeawayBody) => patchJson<TakeawayView>(`${base(spoke)}/takeaways/${encodeURIComponent(id)}`, body),
  patchRequirement: (spoke: string, id: string, body: PatchRequirementBody) => patchJson<TranscriptRequirement>(`${base(spoke)}/requirements/${encodeURIComponent(id)}`, body),
}
